export enum TestGroup {
  TEST_GROUP_A = 'A',
  TEST_GROUP_B = 'B',
}

export enum DocumentType {
  TERMS_AND_CONDITIONS = 'Ehdot',
}

export enum LocalizationNamespace {
  individualLife = 'individualLife',
}
export interface LinkObject {
  linkUrl: string;
  linkText: string;
}

export const isLinkObject = (text: string | LinkObject): text is LinkObject => {
  return (
    typeof text === 'object' &&
    text !== null &&
    'linkUrl' in text &&
    'linkText' in text &&
    typeof text.linkUrl === 'string' &&
    typeof text.linkText === 'string'
  );
};
